module.exports = __webpack_public_path__ + "img/quick-label-print-button-ru.270c455b.png";